import { render, staticRenderFns } from "./DebitCardIssueCard.vue?vue&type=template&id=53cf12f6"
import script from "./DebitCardIssueCard.vue?vue&type=script&lang=js"
export * from "./DebitCardIssueCard.vue?vue&type=script&lang=js"
import style0 from "./DebitCardIssueCard.vue?vue&type=style&index=0&id=53cf12f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports